"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleConfigurationMockItem = void 0;
const enums_1 = require("../../../enums");
exports.vehicleConfigurationMockItem = {
    id: '5f84161933ed22001d27ba2e',
    interiors: null,
    name: 'EQC400 4M AMG Edition',
    price: 699000,
    priceExcludingVat: 699000,
    optionPackages: [],
    salesPackages: [
        {
            additionalPrice: null,
            id: '5f8427a433ed22001d27bab2',
            name: 'AMG Edition',
            equipment: [
                'Amg line: amg interiør og amg eksteriør',
                'Sommer og vinterhjul',
                '20″ amg lettmetallfelg',
                'Metallic lakk.kjøreassistentpakke: aktiv avstandsassistent distronic med styreassistent',
                'Distronic plus med styreassistent',
                'Pre-safe® system.smartphonepakke: apple carplay',
                'Android auto.parkingspakke: aktiv parkeringsasssistent med parktronic',
                '360° kamera',
                'Tilhengerfeste',
                'Bagasjeromsnett.',
            ],
        },
    ],
    sku: 'EQC400 4M NO6',
    pricing: {
        customerAdvantage: -34620,
        customerPrice: null,
        extraDeliveryCharge: 9900,
        extraImporterSupport: -20000,
        extraOneTimeFee: 2400,
        extraWreckage: 2400,
        indicativePrice: 686320,
        margin: null,
        netCustomerPrice: null,
        remainder3630: null,
        remainder3645: null,
        retailerMargin: null,
        retailerSupport: -14620,
        suggestedVehiclePrice: 627000,
        suggestedVehiclePriceExcludingVat: 627000,
        suggestedEquipmentPrice: 61720,
        suggestedEquipmentPriceExcludingVat: 61720,
        grossCustomerPrice: 688720,
        grossCustomerPriceExcludingVat: 688720,
        indicativePriceExcludingVat: 686320,
        retailerSupportExcludingVat: -14620,
        customerAdvantageExcludingVat: -34620,
        vehicleRoadTax: 2400,
        vehicleRoadTaxExcludingVat: 2400,
        retailerMarginVehicle: '9%',
        retailerMarginEquipment: '9%',
        retailerBasicMargin: 61768,
        retailerBasicMarginExcludingVat: 61768,
        retailerCampaignMargin: 47148,
        retailerCampaignMarginExcludingVat: 47148,
        residualValue3y30k: 415000,
        residualValue3y30kExcludingVat: 415000,
        residualValue3y45k: 401369,
        residualValue3y45kExcludingVat: 401369,
        residualValue3y60k: 381587,
        residualValue3y60kExcludingVat: 381587,
        residualValue4y40k: 361964,
        residualValue4y40kExcludingVat: 361964,
        residualValue4y60k: 335800,
        residualValue4y60kExcludingVat: 335800,
        leasingBasisPrice: 686320,
        leasingInterestRate: '1.99%',
        loanInterestRate: '2.49%',
    },
    accessories: [
        {
            id: '5f842b4d33ed22001d27bb08',
            name: 'Navkopper',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/2/1/fragilebox.png',
                },
            ],
            price: 630,
            priceExcludingVat: 625,
            isRecommended: false,
            vat: 0,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 93.75,
            sku: 'A17140001259040',
            description: 'Navkopper sett a 4 stk',
            retailPriceExcludingVat: 531.25,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4c33ed22001d27bb06',
            name: 'Adapter',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/16/6/a1778202901.jpg',
                },
            ],
            price: 270,
            priceExcludingVat: 214.01,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 32.1,
            sku: 'A1778202901',
            description: 'MI adapter kabel NTG6',
            retailPriceExcludingVat: 181.91,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4c33ed22001d27bb04',
            name: 'Speildeksel',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/16/13/a2058110100.jpg',
                },
            ],
            price: 3190,
            priceExcludingVat: 2544.14,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 381.62,
            sku: 'A2058110100',
            description: 'Speildeksel carbon stil',
            retailPriceExcludingVat: 2162.52,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4b33ed22001d27bb02',
            name: 'Skiboks',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/11/29/skiboks.png',
                },
            ],
            price: 12650,
            priceExcludingVat: 9520,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 1428,
            sku: 'SKG830T',
            description: 'Takboks Skiguard',
            retailPriceExcludingVat: 8092,
            marginExcludingVat: null,
            assemblyHours: 0.5,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4b5a99b8001c1daeed',
            name: 'Lasterholder',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/2/1/fragilebox.png',
                },
            ],
            price: 3940,
            priceExcludingVat: 3150.87,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 472.63,
            sku: 'A2938900000',
            description: 'Lasteholder Mercedes-Benz',
            retailPriceExcludingVat: 2678.24,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4a5a99b8001c1daeeb',
            name: 'Modellbil',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/2/1/fragilebox.png',
                },
            ],
            price: 2530,
            priceExcludingVat: 2017.91,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 302.69,
            sku: 'B66963758',
            description: 'Modellbil EQC Graphite grey (1:18)',
            retailPriceExcludingVat: 1715.22,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4a33ed22001d27bb00',
            name: 'Barnesete',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/16/14/a0009701302.jpg',
                },
            ],
            price: 5740,
            priceExcludingVat: 4586.88,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 688.03,
            sku: 'A0009701302',
            description: 'Barnesete Baby Safe Plus (inntil 13kg)',
            retailPriceExcludingVat: 3898.85,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4933ed22001d27bafe',
            name: 'Sykkeholder',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/16/4/2-sykler-a0008901700-for-3-sykler-a0008901800.jpg',
                },
            ],
            price: 11260,
            priceExcludingVat: 9005.59,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 1350.84,
            sku: 'A0008901800',
            description: 'Sykkelholder bak (3 sykler) med kode 550',
            retailPriceExcludingVat: 7654.75,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b4833ed22001d27bafc',
            name: 'Sykkeholder',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/11/13/sykkelholder.png',
                },
            ],
            price: 9580,
            priceExcludingVat: 7659.51,
            isRecommended: false,
            vat: 25,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 1148.93,
            sku: 'A0008901700',
            description: 'Sykkelholder bak (2 sykler) med kode 550',
            retailPriceExcludingVat: 6510.58,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b475a99b8001c1daee7',
            name: 'Gummimatter',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/11/15/bagasjeromsmatte.jpeg',
                },
            ],
            price: 420,
            priceExcludingVat: 415.58,
            isRecommended: false,
            vat: 0,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 62.34,
            sku: 'A25368038039G33',
            description: 'Gummimatter bak',
            retailPriceExcludingVat: 353.24,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b485a99b8001c1daee9',
            name: 'Bagasjeromsmatte',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/11/14/bagasjeromsmatte.jpeg',
                },
            ],
            price: 790,
            priceExcludingVat: 790,
            isRecommended: false,
            vat: 0,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 118.5,
            sku: 'MER6031',
            description: 'Bagasjeromsmatte gummi',
            retailPriceExcludingVat: 671.5,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
        {
            id: '5f842b475a99b8001c1daee5',
            name: 'Gummimatter',
            images: [
                {
                    url: 'https://media.crystallize.com/bos-qa/20/9/11/16/bagasjeromsmatte.jpeg',
                },
            ],
            price: 770,
            priceExcludingVat: 765.57,
            isRecommended: false,
            vat: 0,
            manufacturer: null,
            customerPrice: null,
            retailPrice: null,
            margin: 114.84,
            sku: 'A25368037039G33',
            description: 'Gummimatter foran',
            retailPriceExcludingVat: 650.73,
            marginExcludingVat: null,
            assemblyHours: 0,
            assemblyPrice: null,
            assemblyPriceExcludingVat: 1200,
        },
    ],
    model: {
        year: 2021,
        id: '5f84161633ed22001d27ba23',
        consumption: '232,0- 205,0 Wh/km',
        luggageVolume: 500,
        seatCount: 5,
        transmission: 'Automatgir',
        make: enums_1.MAKE.Mercedes,
        name: 'EQC400 4M ',
        effect: '408 hk',
        powerTrain: 'Firehjulsdrift',
        salesArticle: 'EQC400 4M ',
        series: 'EQC',
        towingCapacity: '1800 kg',
        vehicleType: 'EL',
        bodywork: {
            name: 'EQC400 4M ',
            type: enums_1.VehicleBodyworkType.SUV,
        },
        electricProps: {
            batteryCapacity: '85 kWh',
            chargingCapacityAC: '7,4 kW',
            chargingCapacityDC: '110 kW',
            electricRange: '376-417 km',
        },
        equipment: [
            {
                equipment: [
                    '4matic firehjulstrekk',
                    'Mbux inkl. touchpad',
                    'Multibeam led-lys',
                    '110 kw hurtiglader ccs',
                    'Ladekabel for vanlig stikkontakt',
                    'Ladekabel for wallbox',
                    'Easy-pack elektrisk bakluke',
                    'Keyless-go komfortpakke.oppbevaringspakke: 12v uttak i bagasjerom',
                    '2 usb-uttak i baksetet',
                    'Oppbevaringsrom i bagasjerom',
                    'Mørke ruter bak.setekomfortpakke: forseter elektrisk justerbare i høyde og rygg',
                    '4-veis korsryggstøtte',
                    'Eq remote- og navigasjonstjenester',
                    'Multifunksjonsratt i skinn',
                    'Isofix barnesetefester i ytre bakseter',
                    'Eq komfortunderstell m.m.',
                ],
                name: 'Standardutstyr',
            },
        ],
        fuel: {
            name: 'EQC400 4M ',
            type: enums_1.VehicleFuelType.ELECTRIC,
        },
        images: [
            {
                altText: null,
                width: null,
                url: 'https://media.crystallize.com/bos-qa/20/9/2/2/coveredcar.png',
            },
        ],
    },
    tires: [
        {
            id: '5f842bf95a99b8001c1daf2c',
            name: 'NOWA03953/NOWA03955',
            images: [
                {
                    altText: null,
                    width: null,
                    url: 'https://media.crystallize.com/bos-qa/20/8/10/3/winter-tire-set.png',
                },
            ],
            rimManufacturer: 'Daimler',
            tireManufacturer: 'Nokian',
            nobos: 'NOWA03953/NOWA03955',
            type: null,
            description: 'Vinterhjul 20" med amg felger',
            spikes: false,
            winterWheel: true,
            additionalPrice: 50300,
            additionalPriceExcludingVat: 40240,
            isRecommended: false,
            vat: 0,
            retailerMargin: 0,
        },
        {
            id: '5f842bf85a99b8001c1daf2a',
            name: 'NOWA03885/NOWA03887',
            images: [
                {
                    altText: null,
                    width: null,
                    url: 'https://media.crystallize.com/bos-qa/20/8/10/3/winter-tire-set.png',
                },
            ],
            rimManufacturer: 'Daimler',
            tireManufacturer: 'Nokian',
            nobos: 'NOWA03885/NOWA03887',
            type: null,
            description: 'Vinterhjul 20" felg med blå aspekt',
            spikes: false,
            winterWheel: true,
            additionalPrice: 36000,
            additionalPriceExcludingVat: 28800,
            isRecommended: false,
            vat: 0,
            retailerMargin: 0,
        },
        {
            id: '5f842bf733ed22001d27bb5b',
            name: 'NOWA03623/NOWA03625',
            images: [
                {
                    altText: null,
                    width: null,
                    url: 'https://media.crystallize.com/bos-qa/20/9/16/18/nowa03623-nowa03625.jpg',
                },
            ],
            rimManufacturer: 'Daimler',
            tireManufacturer: 'Nokian',
            nobos: 'NOWA03623/NOWA03625',
            type: null,
            description: 'Vinterhjul 20"',
            spikes: false,
            winterWheel: true,
            additionalPrice: 35200,
            additionalPriceExcludingVat: 28160,
            isRecommended: true,
            vat: 0,
            retailerMargin: 0,
        },
        {
            id: '5f842bf75a99b8001c1daf28',
            name: 'NOWA03618/NOWA03620',
            images: [
                {
                    altText: null,
                    width: null,
                    url: 'https://media.crystallize.com/bos-qa/20/9/16/17/nowa03618-nowa03620.jpg',
                },
            ],
            rimManufacturer: 'Daimler',
            tireManufacturer: 'Nokian',
            nobos: 'NOWA03618/NOWA03620',
            type: null,
            description: 'Vinterhjul 19"',
            spikes: true,
            winterWheel: true,
            additionalPrice: 32900,
            additionalPriceExcludingVat: 26320,
            isRecommended: false,
            vat: 0,
            retailerMargin: 0,
        },
        {
            id: '5f842bf633ed22001d27bb59',
            name: 'NOWA03619/NOWA03621',
            images: [
                {
                    altText: null,
                    width: null,
                    url: 'https://media.crystallize.com/bos-qa/20/9/16/16/nowa03619-nowa03621.jpg',
                },
            ],
            rimManufacturer: 'Daimler',
            tireManufacturer: 'Nokian',
            nobos: 'NOWA03619/NOWA03621',
            type: null,
            description: 'Vinterhjul 19"',
            spikes: false,
            winterWheel: true,
            additionalPrice: 32400,
            additionalPriceExcludingVat: 25920,
            isRecommended: false,
            vat: 0,
            retailerMargin: 0,
        },
    ],
    rims: 'RRR',
    varnishes: [
        {
            id: '5f842d775a99b8001c1daf5e',
            name: 'Hyacinth red metallic',
            varnishCode: '996',
            type: 'Metallic designo',
            hexCode: null,
            additionalPrice: 2860,
            additionalPriceExcludingVat: 2288,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
        {
            id: '5f842d765a99b8001c1daf5c',
            name: 'Diamond white bright',
            varnishCode: '799',
            type: 'Metallic designo',
            hexCode: null,
            additionalPrice: 5870,
            additionalPriceExcludingVat: 4696,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
        {
            id: '5f842d765a99b8001c1daf5a',
            name: 'Selenite grey magno',
            varnishCode: '297',
            type: 'Metallic designo',
            hexCode: null,
            additionalPrice: 11460,
            additionalPriceExcludingVat: 9168,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
        {
            id: '5f842d7433ed22001d27bb8c',
            name: 'High-tech silver',
            varnishCode: '922',
            type: null,
            hexCode: null,
            additionalPrice: 0,
            additionalPriceExcludingVat: 0,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
        {
            id: '5f842d7533ed22001d27bb8e',
            name: 'Selenite grey',
            varnishCode: '992',
            type: 'Metallic',
            hexCode: null,
            additionalPrice: 0,
            additionalPriceExcludingVat: 0,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
        {
            id: '5f842d7333ed22001d27bb8a',
            name: 'Brilliantblue',
            varnishCode: '896',
            type: 'Metallic',
            hexCode: null,
            additionalPrice: 0,
            additionalPriceExcludingVat: 0,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
        {
            id: '5f842d735a99b8001c1daf58',
            name: 'Cavansite blue',
            varnishCode: '890',
            type: 'Metallic',
            hexCode: null,
            additionalPrice: 0,
            additionalPriceExcludingVat: 0,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
        {
            id: '5f842d7233ed22001d27bb88',
            name: 'Graphite grey',
            varnishCode: '831',
            type: 'Metallic',
            hexCode: null,
            additionalPrice: 0,
            additionalPriceExcludingVat: 0,
            isRecommended: false,
            vat: 0,
            retailerMargin: 370,
        },
    ],
};
//# sourceMappingURL=vehicle-configuration.js.map